import { useEffect, useRef, useState } from "react";
import { useUrlParams } from "@common/hooks/useUrlParams.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery.ts";
import { downloadViaStreamingEndpoint } from "@common/api/downloadFile.ts";
import { ExportProps } from "./Export.tsx";

export function useExport(props: ExportProps) {
    const [exportStatus, setExportStatus] = useState<"Loading" | "Succes" | "Failure">("Loading");

    const urlParams = useUrlParams();
    const params = urlParams.getUrlParams;

    const token = params.getValue("token");
    const fileName = params.getValue("fileName");

    function getFileName() {
        if (fileName) {
            const decoded = decodeURIComponent(fileName);
            const hasExtension = /\.[a-z0-9]{2,5}$/i.test(decoded);
            return hasExtension ? decoded : decoded + ".xlsx";
        }

        return "privacy-data-export.zip";
    }

    const exportFileMutation = useDotLegalMutation(getExport, {
        onSuccess: (status: number) => {
            if (status === 200) {
                setExportStatus("Succes");
            } else {
                setExportStatus("Failure");
            }
        },
    });

    const hasStarted = useRef(false);

    useEffect(() => {
        if (!hasStarted.current) {
            hasStarted.current = true;
            exportFileMutation.mutate();
        }
    }, [exportFileMutation]);

    async function getExport(): Promise<number> {
        const name = getFileName();
        return await downloadViaStreamingEndpoint(`${props.url}/download-url?token=${token}&fileName=${encodeURIComponent(name)}`, name);
    }

    return { exportStatus };
}
